module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4838eb6833f72e35dff3df69f5861eec.png";